export const CATEGORIES = "blogs/categoriesFillter";
export const AUTHOR = "blogs/authorFillter";